export const parseNumberFromString = value => Number.parseFloat(value.replaceAll(',', '.').replaceAll(/[^\d.]/g, ''));
//# sourceMappingURL=parseNumberFromString.js.map